/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect } from 'react';
import Modal from '../../Common/Modal';
import { withTranslation } from 'react-i18next';
import { showRegister, showLogin, errorHandler, addSubscription } from '../../../utils/gigyaScreen';
import { useSponsorValue } from '../../../context/sponsorContext';
import { userLoginStatus } from '../../../actions/sponsorAction';
import { REGISTERED, ACCOUNT_SUBSCRIPTION, ANONYMOUS } from '../../../constants/globalConstants';
import { checkSubscription, getLoggedInStatus } from '../../../utils/utils';
import * as track from '../../../utils/analytics';
import MU from '../../../constants/muConstants';
import { redirectToIDMLogin, redirectToIDMSignUp } from '../../../utils/idmUtils';
const CollectionAccessModal = (props) => {
  const [
    { isUserLogin, userLoginDetail, isUserSubscribe, isLoginChecked, isUserSkyId },
    dispatch,
  ] = useSponsorValue();
  const {
    closeModal,
    onSkip,
    successCallback = false,
    contentAccess,
    modalId,
    analyticsObj,
    onCloseBtn,
  } = props;

  useEffect(() => {
    const obj = getAnalytics(contentAccess === REGISTERED, false);
    obj && track.analytics(obj);
  }, []);

  const getAnalytics = (isRegistered, flag) => {
    let obj = {
      content_status: contentAccess,
      subscription_status: getLoggedInStatus({
        isLoginChecked,
        isUserLogin,
        isUserSubscribe,
        isUserSkyId,
      }),
      trackType: isRegistered ? 'registrationBenefits' : 'subscriptionBenefit',
    };
    if (flag) {
      obj.container_type = isRegistered ? 'registration-benefit' : 'subscription-benefit';
    }
    if (analyticsObj) {
      return { ...analyticsObj, ...obj };
    }
    return obj;
  };

  const getLoginDetail = () => {
    if (!MU.isIDMEnabled) {
      if (window.gigya) {
        var evalResponse = function (response) {
          if (response.errorCode === 0) {
            userLoginStatus(dispatch, response);
            const isSubscribedContent = contentAccess === ACCOUNT_SUBSCRIPTION;
            const userSubscribed = checkSubscription(response);
            if (!isSubscribedContent || (isSubscribedContent && userSubscribed)) {
              successCallback && successCallback({ showContent: true });
            }
          } else {
            userLoginStatus(dispatch, false);
            errorHandler(response);
          }
        };
        window.gigya && window.gigya.accounts.getAccountInfo({ callback: evalResponse });
      }
    } else {
      const isSubscribedContent = contentAccess === ACCOUNT_SUBSCRIPTION;
      return successCallback && successCallback({ showContent: true, isSubscribedContent });
    }
  };

  const openRegister = () => {
    const isRegistered = contentAccess === REGISTERED;
    const obj = getAnalytics(isRegistered, true);
    if (isUserLogin && userLoginDetail && userLoginDetail.UID) {
      obj.trackType = 'addSubscription';
      obj.destination_url = MU && MU.addSubscriptionUrl;
      delete obj.created_datetime;
      track.analytics(obj);
      addSubscription({ param: userLoginDetail.UID, type: 'uid' });
    } else {
      if (MU.isIDMEnabled) {
        redirectToIDMSignUp();
      } else showRegister(getLoginDetail, true, !isRegistered, obj);
    }
  };
  const openLogin = () => {
    const isRegistered = contentAccess === REGISTERED;
    const obj = getAnalytics(isRegistered, true);
    if (MU.isIDMEnabled) {
      redirectToIDMLogin();
    } else showLogin(getLoginDetail, true, !isRegistered, obj);
  };

  const getHeading = () => {
    return contentAccess === REGISTERED ? 'sign for united' : 'subscribe to mutv';
  };

  const getMessage = () => {
    if (!isUserLogin && [REGISTERED, ACCOUNT_SUBSCRIPTION].includes(contentAccess)) {
      return (
        <p className="inner-text">
          {`You must be ${
            contentAccess === REGISTERED ? 'registered' : 'subscribed'
          } to view this content Already have an account?`}{' '}
          <a href="#" role="link" onClick={() => openLogin()}>
            Log In
          </a>
        </p>
      );
    } else if (!isUserSubscribe && contentAccess === ACCOUNT_SUBSCRIPTION) {
      return <p className="inner-text">You must be subscribed to view this content</p>;
    }
    return null;
  };
  const getButtons = () => {
    const isRegistred = contentAccess === REGISTERED;
    return (
      <div className="red-btn-skew btn" onClick={() => openRegister()}>
        <a href="/#" role="link">
          <span>{isRegistred ? 'sign up' : 'subscribe now'}</span>
        </a>
      </div>
    );
  };

  return (
    <Modal
      containerClass="dialog small-modal"
      customElm={true}
      closeModal={closeModal}
      showClose={false}
      modalId={modalId}
    >
      <div id="small-modal">
        <div className="small-modal__body">
          <div className="small-modal__innercontent">
            <h3>{getHeading()}</h3>
            {getMessage()}
            {getButtons()}
            <div className="white-btn-skew btn" onClick={(e) => onSkip(e)}>
              <a href="/#" role="link">
                <span>Skip</span>
              </a>
            </div>
            <div className="white-btn-skew btn no-bdr" onClick={() => onCloseBtn()}>
              <a href="/#" role="link">
                <span>close</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default withTranslation()(CollectionAccessModal);
